import {  UserState } from "@/types";
import { Module } from "vuex";
import {
  SaveUser,
  SaveParty,
  buildSelectedUser,
  getTeamFromUserId,
  getTeamMembersByManagerCode,
  userList,
  getManagerByTeam,
  UpdateTeamMembers,
  savePartyRoleNetwork,
  getPerson,
  resetPasswordFromAdmin,
  addUserAuthorities,
  getUserLogs,
  getPartyRoleNetwork,
  updatePartyRoleNetwork,
  saveGroup,
  searchGroupList,
  getSecurityGroup,
  updateGroup,
  deleteSecurityGroup,
  getUserOrch,
  saveUserOrch,
} from "@/store/services/user/userService";
import { getUser, signUp } from "@/store/services/auth";
import Notify from 'quasar/src/plugins/Notify.js';;
import store from "@/store";
import { deepClone } from "@/utils";
import i18n from "@/i18n";
import {
  getNetwork,
  getNetworkNode,
} from "@/store/services/offerService";
import router from "@/router";

let rolesParty : any

const createDefaultUserRecord = () => ({
  objectType: "odm.user.leaseforgeuser",
  systemUid: "odm-user",
  businessData: null,
  daaq: "/",
  username: "",
  applicationName: "TWDDistribution",
  firstName: "",
  lastName: "",
  email: "",
  associatedParty: {
    objectType: "odm.party.party.person",
    systemUid: "odm-party",
    resourceUid: "",
  },
  personalAuthorities: [],
  userGroups: [],
  personalDAAQs: [],
  accountNotExpired: true,
  accountNotLocked: true,
  credentialsNotExpired: "true",
  enabled: true,
  defaultLanguage: null,
  preferredLanguages: [],
  externalReference: "",
  phoneNumber: "",
  roles: [],
});

export const generateTemporaryPassword = (length = 12): string => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
  const cryptoApi = globalThis.crypto;
  if (!cryptoApi) {
    throw new Error("Secure random generator is not available");
  }
  let password = "";
  const randomValues = new Uint32Array(length);
  cryptoApi.getRandomValues(randomValues);

  for (let i = 0; i < length; i += 1) {
    const randomIndex = randomValues[i] % chars.length;
    password += chars[randomIndex];
  }

  return password;
};

const userModule: Module<UserState, any> = {
  
  namespaced: true,
  state: {
    mode: "add",
    selectedUserDetails: {},
    team: {},
    teamMembers: [],
    userParty: {},
    managers: [],
    networkDetails: {
      network: {},
      networkNode: [],
      networkNodePicklist: [],
    },
    temporaryPassword: "",
    userLogs: [],
    selectedGroup:{
      authorities: [],
      groupDAAQs: [],
      objectType: "odm.user.securitygroup",
      systemUid: "odm-user",
      resourceUid: "",
      reference: "",
      daaq: "/",
      validity: {
        from: "",
        until: "",
      }
    }
  },

  getters: {
    getUserselectedInit() {
      return {
        objectType: "odm.user.leaseforgeuser",
        systemUid: "odm-user",
        businessData: null,
        daaq: "/",
        username: "",
        applicationName: "TWDDistribution",
        firstName: "",
        lastName: "",
        email: "",
        associatedParty: {
          objectType: "odm.party.party.person",
          systemUid: "odm-party",
          resourceUid: "",
        },
        personalAuthorities: [],
        userGroups: [],
        personalDAAQs: [],
        accountNotExpired: true,
        accountNotLocked: true,
        credentialsNotExpired: "true",
        enabled: true,
        defaultLanguage: null,
        preferredLanguages: [],
      };
    },
    getPartyInit() {
      return {
        objectType: "odm.party.party.person",
        systemUid: "odm-party",
        businessData: null,
        daaq: "/",
        reference: null,
        taxID: null,
        taxGeographicZone: null,
        classifications: [],
        roles: [
          {
            objectType: "odm.party.partyrole",
            role: {
              objectType: "odm.party.role",
              resourceUid: "EMPLOYEE",
            },
            status: {
              objectType: "odm.party.rolestatus",
              resourceUid: "ACTIVATED",
            },
            daaq: "/",
          },
        ],
        contacts: [],
        addresses: [],
        statusHistory: [],
        accounts: [],
        correspondents: [],
        financialExposures: [],
        generatedDocuments: [],
        currentStatus: null,
        title: null,
        firstName: "",
        middleName: null,
        familyName: "",
        birthDate: "1970-01-01",
        birthplace: null,
        nbOfChildren: null,
        gender: null,
        nbOfDependent: null,
        maritalStatuses: [],
        citizenships: [],
        ids: [],
        revenues: [],
        jobs: [],
        legalEntity: null,
      };
    },
    getTeamInit() {
      return {}
    },
    getTeamMembersInit() {
      return []
    },
    getnetworkDetailsInit() {
      return {
        networkDetails: {
          network: {},
          networkNode: [],
          networkNodePicklist: [],
        }
      }
    }
  },

  actions: {
    /**
     * Searches for user based on the given filter.
     * @param {object} context - The context object.
     * @param {object} payload - The payload object containing the filter and a callback function.
     * @return {void}
     */
    searchUser(context, payload) {
      // Gets the callback function from the payload.
      const { filter,offset , limit, callback } = payload;
      // Calls the `userList()` function to fetch the list of user.
      userList(filter,offset,limit)
        .then((response) => {
          // Passes the response to the callback function.
          callback(response);
        })
        .catch((err) => {
          // Logs the error to the console.
          console.error(err);
        });
    },
    searchGroup(context, payload) {
      const { filter,offset , limit, callback } = payload;
      searchGroupList(filter,offset , limit,)
        .then((response:any) => {
          callback(response);
        })
        .catch((err:any) => {
          console.error(err);
        });
    },
    setMode({ commit }, payload) {
      commit("setMode", payload);
    },
    resetUser({ commit }, payload) {
      commit("resetUser", payload);
    },

    updatePassword({ commit }, payload) {
      commit("updatePassword", payload);
    },
    updatePasswordHandler({ commit }, payload) {
      return resetPasswordFromAdmin(payload.username, payload.newPassword)
        .then((response) => {
          store.state.userModule.selectedUserDetails.temporaryPassword = true;
          return { success: true, message: i18n.global.t("main.auth.passwordResetSuccess") };
        })
        .catch((error: any) => {
  let errorMessage = i18n.global.t(
    "main.auth.passwordResetError"
  );

  const apiError =
    error?.response?.data?.message?.toLowerCase() ||
    error?.message?.toLowerCase() ||
    "";

  if (apiError.includes("special character")) {
    errorMessage = i18n.global.t(
      "main.connect.passwordValidationError"
    );
  } else if (
    apiError.includes("8 character") ||
    apiError.includes("eight character")
  ) {
    errorMessage = i18n.global.t(
      "main.connect.passwordTooShort"
    );
  } else if (apiError.includes("uppercase")) {
    errorMessage = i18n.global.t(
      "main.connect.passwordNoUppercase"
    );
  } else if (apiError.includes("lowercase")) {
    errorMessage = i18n.global.t(
      "main.connect.passwordNoLowercase"
    );
  } else if (
    apiError.includes("number") ||
    apiError.includes("digit")
  ) {
    errorMessage = i18n.global.t(
      "main.connect.passwordNoNumber"
    );
  } else if (
    apiError.includes("same password") ||
    apiError.includes("already used")
  ) {
    errorMessage = i18n.global.t(
      "main.connect.passwordRepeated"
    );
  }

  const passwordResetError = new Error(errorMessage) as Error & {
    success: boolean;
  };

  passwordResetError.success = false;

  throw passwordResetError;
});
    },
    updateTeam({ commit }, payload) {
      commit("updateTeam", payload);
    },
    executeSelectUser({ commit }, payload) {
      const { mode, user, callback } = payload;
      const credentialsNotExpired = mode ==="add" ? store.state.userModule.selectedUserDetails.credentialsNotExpired : undefined
      const externalReference = mode ==="add" ? store.state.userModule.selectedUserDetails.externalReference : undefined
      getUser(user.id)
        .then(async (user) => {
          if (user?.data) {

            getTeamFromUserId(user.data.resourceUid)
              .then((res) => {

                commit("setTeam", res[0]);
                if (res && res.length > 0) {
                  getTeamMembersByManagerCode(
                    store.state.userModule.team.config.manager_code
                  )
                    .then((response) => {
                      commit("setTeamMembers", response);
                    })
                    .catch((e: any) => console.error(e));
                }
              })
              .catch((e: any) => console.error(e));
            const userSelected = await buildSelectedUser(user.data, payload.user);
            if (mode && mode === "add") {
              if(credentialsNotExpired === "true" && user.data.credentialsNotExpired === false) {
                store.state.userModule.selectedUserDetails.credentialsNotExpired = true  
                userSelected.credentialsNotExpired = true 
              }
              if(externalReference) {
                store.state.userModule.selectedUserDetails.externalReference = externalReference  
                userSelected.externalReference = externalReference 
              }
            }
            store.state.userModule.selectedUserDetails.resourceUid = userSelected.resourceUid
            if (mode && mode === "add") {
              store.state.userModule.selectedUserDetails.userGroups.forEach((item: any) => delete item.resourceUid)
            }
           



           await  getPerson(user.data.associatedParty?.resourceUid).then((person) => {
              store.state.userModule.userParty = person
              if (mode && mode === "add") {
                store.state.userModule.selectedUserDetails?.roles?.forEach((r:any) => {
                  let role = {
                    objectType: "odm.party.partyrole",
                    role: {
                      objectType: "odm.party.role",
                      resourceUid: r.value,
                    },
                    status: {
                      objectType: "odm.party.rolestatus",
                      resourceUid: "ACTIVATED",
                    },
                    daaq: "/",
                  }
                  store.state.userModule.userParty.roles.push(role)
                });

                


                  store.dispatch("userModule/createUser", {
                    notifyType: "Addsuccess",
                    role: rolesParty,
                    callback: () => { }
                  });
              }
              
              userSelected.roles=[]
                for (const role of person.roles){
                  userSelected.roles.push({
                    label :   i18n.global.t("demand.party.roles.".concat(role.role.resourceUid)),
                    value : role.role.resourceUid   
                  })
                }
              
              
              commit("saveUser", userSelected);
              
  

              getUserLogs(userSelected.username).then((res) => {
                commit("setUserLogs", res);
              }).catch((e: any) => console.error(e));
            }).catch((e: any) => console.error(e));


            callback();
          }
        })
        .catch((err) => {
          Notify.create({
            message: `Error searching Good \n ${err}`,
            color: "negative",
          });
        });
    },
    async executeSelectUserOrch({ commit }, payload){
      const { user, callback } = payload;
      const userOrch = await getUserOrch(user.id)
      if(userOrch.team){

        commit("setTeam", userOrch.team);
        getTeamMembersByManagerCode(
          store.state.userModule.team.config.manager_code
        )
          .then((response) => {
            commit("setTeamMembers", response);
          })
          .catch((e: any) => console.error(e));
      }
      const userSelected = await buildSelectedUser(userOrch, payload.user);
      store.state.userModule.userParty = userOrch.associatedParty.rawData
      store.state.userModule.networkDetails=userOrch.networkDetails
      commit("saveUser", userSelected);
      callback();
    },
    async saveUserOrch({ commit }, payload){
      const { user,networkDetails,team,temporaryPassword } = payload;
      const userDetails = deepClone(user);
      if (!user.resourceUid) {
        const filter = {
          username: userDetails.username,
        };

        try {
          const response = await userList(filter);
          if (response.data && response.data.length > 0) {
            Notify.create({
              message: i18n.global.t("user.errorUserAlreadyCreated"),
              color: 'negative',
            });
            return;
          }

        } catch (err) {
          console.error(err);
          return;
        }
      }
      await saveUserOrch(userDetails,networkDetails,team,temporaryPassword)
      store.dispatch("userModule/applyDefaultUserRecord");
      store.dispatch("releaseLockState");
      router.push("/userAdmin/list");
      
    },
    getManagerByTeam({ commit }, payload) {
      getManagerByTeam(payload)
        .then((res: any) => {
          commit("setManager", res[0]);
        })
        .catch((e: any) => console.error(e));
    },
    resetUserParty({ commit }, payload) {
      commit("resetUserParty", payload);
    },
    setManagers({ commit }, payload) {
      const managers = payload.map((el: { id: string; manager_code: string }) => {
        return {
          team_id: el.id,
          manager_code: el.manager_code,
        };
      });

      commit("setManagers", managers);
    },
    network({ commit }, payload) {
      const { filter, callback } = payload;
      getNetwork(filter)
        .then((res) => { 
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    networknode({ commit }, payload) {
      const { filter, callback } = payload;
      getNetworkNode(filter)
        .then((res) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },

    async saveUser({ commit }, payload) {
      const { user, callback } = payload;
      const userDetails = deepClone(user);
       rolesParty = userDetails.roles

      let createUserPayload = {
        notifyType: "",
        callback: callback
      }
      delete userDetails.roles
      if (!userDetails.resourceUid) {
        createUserPayload.notifyType = "Addsuccess";


        userDetails.userGroups = userDetails.userGroups.map((resourceUid: any) => (resourceUid.value));

        const userPayload = {
          username: userDetails.username,
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
          email: userDetails.email,
          userGroups: userDetails.userGroups,
          externalReference : userDetails.externalReference,
          password: generateTemporaryPassword(),
          applicationName: "TWDDistribution",
          phoneNumber: userDetails.phoneNumber,
          daaqList: "/"
        }
        signUp(userPayload).then(async res => { 
          store.dispatch("userModule/updatePasswordHandler", {
            username: userDetails.username,
            newPassword: store.state.userModule.temporaryPassword,
          }); // Commit mutation to update state
          await store.dispatch("userModule/executeSelectUser", {
            mode: "add",
            user: {
              id: res.userId
            },
            callback: () => {
            },
          });
          setTimeout(() => {
            commit("setNewCreatedUser", true);
          }, 2000);
          
          Notify.create({
            message: i18n.global.t('main.dialog.successUser', { username: userDetails.username }),
            color: 'positive'
          });
        }).catch(err => {
          console.log(err);
        });
      } else {
        createUserPayload.notifyType = "Editsuccess";
        store.dispatch("userModule/createUser", {
          notifyType: createUserPayload.notifyType,
          role: rolesParty,
          callback: () => {
            store.dispatch("releaseLockState").then(() => {
              commit("setNewCreatedUser", true)
            })

          }
        });
      } 

    },

    async createUser({ commit }, payload) {
      const { notifyType, callback, role } = payload;

      await SaveParty(store.state.userModule.userParty, role)
        .then(async (res: any) => {
          commit("saveUserParty", res);
          store.state.userModule.selectedUserDetails.associatedParty.resourceUid =
            res.resourceUid;

          for(const roles of  res.roles ){
            for(const node of store.state.userModule.networkDetails.networkNode){
              const rolePayload = {
                body: {
                  "objectType": "odm.party.partyrolenetwork",
                  "systemUid": "odm-party",
                  "businessData": null,
                  "daaq": "/",
                  "partyRole": {
                    "objectType": "odm.party.partyrole",
                    "systemUid": "odm-party",
                    "resourceUid": roles.resourceUid
                  }

                },
                networkNode: node?.config?.id
              }

              if (rolePayload.networkNode){
                  const allPartyRoleRes = await getPartyRoleNetwork(rolePayload)
                  const listPartyRoleRes = allPartyRoleRes.data.filter((s:any) => s.partyRole.resourceUid === roles.resourceUid)
                  if (listPartyRoleRes.length === 0){
                    await savePartyRoleNetwork(rolePayload)
                  }
                  else if (listPartyRoleRes.length === 1){
                    await updatePartyRoleNetwork(listPartyRoleRes[0])
                  }
              }

            }

           }

           const userDetails = store.state.userModule.selectedUserDetails
           delete userDetails.roles
          SaveUser(userDetails)
            .then((user: any) => {
              UpdateTeamMembers(user);

              
              if (store.state.userModule.mode === 'add') {
                addUserAuthorities(user,res.roles)
                  .then((authorities: any) => {
                    store.dispatch("userModule/applyDefaultUserRecord");
                    store.dispatch("releaseLockState");
                    store.dispatch("userModule/setMode", "edit")
                    router.push("/userAdmin/list");
                   
                  })
                  .catch((e) => console.error(e));
              }
              else{
                store.dispatch("userModule/applyDefaultUserRecord");
                store.dispatch("releaseLockState");
                 router.push("/userAdmin/list");
              }
              Notify.create({
                message: i18n.global.t("user.dialog." + notifyType),
                color: "positive",
              });
              
              callback()
            })
            .catch((err: any) => {
              console.error(err);
              Notify.create({
                message: i18n.global.t("user.dialog.error"),
                color: "negative",
              });
            });
        })
        .catch((err: any) => {
          console.error(err);
          Notify.create({
            message: i18n.global.t("user.dialog.error"),
            color: "negative",
          });
        });
    },
    createGroup({ state, commit }, payload) {
      const { group} = payload
      group.resourceUid=group.reference
      delete group.reference
      saveGroup(group).then((res:any) => {
        Notify.create({
            message: "Group Created...",
            color: "positive",
        })
        res.data.authorities = res.data.authorities.map((authorityObj:any) => authorityObj.authority.resourceUid);
        commit('setgroup', res.data);
        
    })
    .catch((e:any) => console.error(e))
        },
        updateGroup({ state, commit }, payload) {
          const { group} = payload
          delete group.reference
          updateGroup(group).then((res:any) => {
            Notify.create({
                message: "Group Updated...",
                color: "positive",
            })
            res.data.authorities = res.data.authorities.map((authorityObj:any) => authorityObj.authority.resourceUid);
            commit('setgroup', res.data);
            
        })
        .catch((e:any) => console.error(e))
            },
        async getGroupEditMode({ commit}, payload) {
          const { groupid } = payload
          if (!groupid) {
              throw new Error('ResourceUid is mandatory!')
          }
          try {
              const group = await getSecurityGroup(groupid)
              group.data.authorities = group.data.authorities.map((authorityObj:any) => authorityObj.authority.resourceUid);
              if (!group.data.validity){
                group.data.validity = {
                  from: "",
                  until: "",
                }
              }
              commit('setgroup', group.data);
              router.push("/group/edit");
          } catch (e) {
              Notify.create({
                  message: 'ERROR: ' + e,
                  color: 'negative'
              })
          }
        },
        deleteSecurityGroup({ commit }, payload) {
          const { resourceUid } = payload
          deleteSecurityGroup(resourceUid)
              .then((res:any) => {
                  Notify.create({
                      message: i18n.global.t("group.messages.deleteSuccess"),
                      color: "positive",
                  })
              })
              .catch((err:any) => {
                  console.error(err);
                  Notify.create({
                    message: err,
                    color: "negative",
                  });
              })
      },

    initUserModule({ commit }) {
      commit("initUserModule");
    },
    applyDefaultUserRecord({ commit }) {
      commit("resetUser", createDefaultUserRecord());
      commit("setNewCreatedUser", false);
      commit("updatePassword", "");
    },
    cleanGroup({ commit }) {
      commit("initGroup");
    }
  },
  mutations: {
    setUserLogs(state, payload) {
      state.userLogs = payload
    },
    setMode(state, payload) {
      state.mode = payload;
    },
    setNewCreatedUser(state, payload) {
      state.newCreatedUser = payload
    },
    resetUser(state, payload) {
      if (state.selectedUserDetails) state.selectedUserDetails = payload;
    },
    saveUser(state, payload) {
      state.selectedUserDetails = payload;
    },
    setTeam(state, payload) {
      state.team = payload;
    },
    setManager(state, payload) {
      state.manager = payload;
    },
    setTeamMembers(state, payload) {
      state.teamMembers = payload;
    },
    resetUserParty(state, payload) {
      if (state.userParty) state.userParty = payload;
    },
    UpdateUserParty(state, payload) {
      state.userParty.firstName = payload.firstName;
      state.userParty.familyName = payload.lastName;
    },
    updatePassword(state, payload) {
      state.temporaryPassword = payload;
    },
    updateTeam(state, payload) {
      state.team = payload;
    },
    setManagers(state, payload) {
      state.managers = payload;
    },
    setNetwork(state, payload) {
      state.networkDetails.network = payload;
    },
    saveUserParty(state, payload) {
      if (state.userParty) state.userParty = payload;
    },
    UpdateassociatedParty(state, payload) {
      if (state.selectedUserDetails) {
        state.selectedUserDetails.associatedParty = payload;
      }
    },
    initUserModule(state) {
      const userPartyGetter = store.getters["userModule/getPartyInit"];
      store.dispatch("userModule/resetUserParty", userPartyGetter);
      const userGetter = store.getters["userModule/getUserselectedInit"]
      store.dispatch("userModule/resetUser", userGetter);
      state.team = {};
      state.teamMembers = [];
      state.networkDetails = {
        network: {},
        networkNode: [],
        networkNodePicklist: [],
      }
    },
    initGroup(state) {
      state.selectedGroup={
        authorities: [],
        groupDAAQs: [],
        objectType: "odm.user.securitygroup",
        systemUid: "odm-user",
        resourceUid: "",
        reference: "",
        daaq: "/",
        validity: {
          from: "",
          until: "",
        }
      }

    },
    setgroup(state, payload) {
      payload.reference=payload.resourceUid
      state.selectedGroup=payload
    }
  },
};
export default userModule;
